<!-- =========================================================================================
    File Name: TheCustomizer.vue
    Description: Template Customizer
    Component Name: TheCustomizer
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="vessel-list">
    <vx-tooltip class="customizer-btn-vessel" text="List vessel" position="left">
      <vs-button
        v-if="collapsed"
        color="warning"
        icon-pack="feather"
        icon="icon-chevrons-left"
        style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
        @click="setCollapsed(false)"
      ></vs-button>
      <vs-button
        v-else
        style="border-top-right-radius: 0;border-bottom-right-radius: 0;"
        color="primary"
        icon-pack="feather"
        icon="icon-list"
        @click.stop="active=!active"
      ></vs-button>
    </vx-tooltip>
    <vs-sidebar
      v-model="active"
      hidden-background
      position-right
      click-not-close
      class="items-no-padding"
    >
      <div class="h-full">
        <div class="customizer-header mt-6 flex items-center justify-between px-6">
          <div>
            <h4>List Vessel</h4>
          </div>
          <div class="flex">
            <div class="flex items-center px-2">
              <chevrons-right-icon
                size="1.5x"
                class="custom-class cursor-pointer"
                @click="setCollapsed(true)"
              ></chevrons-right-icon>
            </div>
            <feather-icon icon="XIcon" class="cursor-pointer" @click.stop="active = false"></feather-icon>
          </div>
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <div class="mt-3 mr-2 ml-2">
          <label for="name">
            <b>Name,MMSI</b>
          </label>
          <vs-input
            id="name"
            v-model="dataSearchVessel.nameOrmmsi"
            class="w-full"
            @keypress.enter="searchVessel()"
          />
          <label for="shiptype">
            <b>Ship type</b>
          </label>
          <v-select
            id="shiptype"
            :options="shipTypes"
            v-model="dataSearchVessel.shipType"
            class="w-full p-1"
            label="name"
          />
          <label for="navigationStatus">
            <b>Navigation status</b>
          </label>
          <v-select
            id="shiptype"
            :options="navigationStatuss"
            v-model="dataSearchVessel.navigationStatus"
            class="w-full p-1"
            label="name"
          />
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-search"
            class="w-full mt-2"
            type="relief"
            @click="searchVessel()"
          >Sarech</vs-button>
        </div>
        <br />
        <center>
          <vs-alert
            :active="statusLoadingVessel"
            color="primary"
            style="width:90%"
            title="Loading...."
          >กำลังโหลดข้อมูลเรือ กรุณารอสักครู่...</vs-alert>
        </center>
        <br />
        <VuePerfectScrollbar class="scroll-area--customizer pt-4 pb-6 pr-2">
          <vs-table v-model="selected" :data="Datasuccess" @selected="handleSelected">
            <template slot="thead">
              <vs-th>MMSI</vs-th>
              <vs-th>Name</vs-th>
            </template>
            <template slot-scope="{data}">
              <tbody>
                <vs-tr v-for="(tr, indextr) in Datasuccess" :data="tr" :key="indextr">
                  <vs-td :data="data[indextr].mmsi">{{ data[indextr].mmsi }}</vs-td>
                  <vs-td :data="data[indextr].name">{{ data[indextr].name }}</vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </VuePerfectScrollbar>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { ChevronsRightIcon } from "vue-feather-icons";
import axios from "axios";
import {
  API_GET_VESSELS,
  API_GET_NAVIGA_STATUS,
  API_GET_SHIP_TYPE,
} from "@/constants/api";
import vSelect from "vue-select";
import { mobileDevice } from "./../../../utils";

export default {
  name: "VesselList",
  components: {
    VuePerfectScrollbar,
    vSelect,
    ChevronsRightIcon,
  },
  props: {
    onActive: {
      type: Function,
      default() {},
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isMobileDevice: mobileDevice(),
      statusLoadingVessel: false,
      active: false,
      valueSearch: "",
      selected: [],
      DataReq: null,
      Datasuccess: [],
      autocompleteText: [],
      SearchName: null,
      Select_navigation_status_name: null,
      Select_icon_type: null,
      Select_ship_type_name: "1",
      dataSearchVessel: {
        nameOrmmsi: "",
        shipType: "",
        navigationStatus: "",
      },
      shipTypes: [],
      navigationStatuss: [],
      accessEmail: "",
      accessToken: "",
      collapsed: false,
    };
  },
  watch: {
    active(val) {
      if (val) {
        this.onActive();
        this.setCollapsed(!val);
      }
    },
    isActive(val) {
      if (!val) {
        this.active = false;
        this.collapsed = false;
      }
    },
  },
  created() {
    this.accessEmail = localStorage.getItem("accessEmail");
    this.accessToken = localStorage.getItem("accessToken");
    const url = API_GET_VESSELS();
    axios
      .get(url, {
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((response) => {
        this.DataReq = response.data;
      })
      .catch((error) => {
        console.log("vessel list API error:", error);
      });
    axios
      .get(API_GET_NAVIGA_STATUS(), {
        params: {
          limit: 100,
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((response) => {
        this.navigationStatuss = response.data;
        this.$vs.loading.close();
      })
      .catch((error) => {
        console.log("Error call apis :", error);
      });
    axios
      .get(API_GET_SHIP_TYPE(), {
        params: {
          limit: 100,
        },
        headers: {
          "X-User-Email": this.accessEmail,
          "X-User-Token": this.accessToken,
        },
      })
      .then((response) => {
        this.shipTypes = response.data;
      })
      .catch((error) => {
        console.log("Error call apis :", error);
      });
  },
  methods: {
    searchVessel() {
      this.statusLoadingVessel = true;
      if (this.dataSearchVessel.shipType == null) {
        this.dataSearchVessel.shipType = "";
      }
      if (this.dataSearchVessel.navigationStatus == null) {
        this.dataSearchVessel.navigationStatus = "";
      }
      axios
        .get("http://rts.excise-online.com/api/vessels.json", {
          params: {
            "q[mmsi_or_name_cont]": this.dataSearchVessel.nameOrmmsi,
            "q[ship_type_id_eq]": this.dataSearchVessel.shipType.id,
            "q[navigation_status_id_eq]": this.dataSearchVessel.navigationStatus
              .id,
          },
          headers: {
            "X-User-Email": this.accessEmail,
            "X-User-Token": this.accessToken,
          },
        })
        .then((response) => {
          if (
            this.dataSearchVessel.nameOrmmsi == "" &&
            this.dataSearchVessel.shipType.id == "" &&
            this.dataSearchVessel.navigationStatus.id == ""
          ) {
            this.Datasuccess = response.data;
          } else {
            this.Datasuccess = [];
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].mmsi != null) {
                this.Datasuccess.push(response.data[i]);
              }
            }
            this.$store.dispatch("updateFilterVessel", this.Datasuccess);
          }

          this.statusLoadingVessel = false;
        })
        .catch((error) => {
          console.log("vessel list API error:", error);
          this.statusLoadingVessel = false;
        });
    },
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.mmsi}`,
        text: `Name: ${tr.name}`,
      });
      this.$store.dispatch("updateSelectVessel", tr);
    },
    setCollapsed(flag) {
      const elem = document.querySelector("#vessel-list");
      const sidebar = elem.getElementsByClassName("vs-sidebar");
      if (flag) {
        sidebar[0].style.width = "0vw";
      } else {
        sidebar[0].style.width = "350px";
      }
      this.collapsed = flag;
    },
  },
};
</script>

<style lang="scss">
#vessel-list {
  .vs-sidebar {
    position: fixed;
    z-index: 52000;
    width: 350px;
    max-width: 90vw;
  }
  @media screen and (max-width: 420px) {
    .h4,
    h4 {
      font-size: calc(14px + 6 * ((100vw - 420px) / 680));
    }
    .b,
    b {
      font-size: calc(12px + 6 * ((100vw - 420px) / 680));
    }
  }
}

.customizer-btn-vessel {
  position: fixed;
  top: 30%;
  right: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  z-index: 50000;
}

.scroll-area--customizer {
  height: calc(100% - 5rem);
  margin-bottom: 30px;
  border-style: inset;
}

.scroll-area--detail {
  height: 150px;
  border-style: inset;
  padding-left: 10px;
  padding-right: 10px;
}

.vessel-img {
  width: 100%;
  height: 150px;
  border-style: solid gray;
  border-radius: 10px;
  margin-top: 3px;
}
.value-text {
  color: blue;
}
.title-text {
  font-weight: bold;
}
.customize22 {
  max-width: 100px;
}
.scale-size {
  position: absolute;
  right: 0px;
  top: 0px;
}
</style>
